import Input from './Input';
import Form from './Form';
import Description from './Description';
import Title from './Title';
import SubmitButton from './SubmitButton';
import ResendCode from './ResendCode';
import Message from './Message';

const PhoneVerification = {
  Form,
  Input,
  Message,
  ResendCode,
  SubmitButton,
  Title,
  Description,
};

export default PhoneVerification;
